import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { stringify } from 'qs'
import axios from 'axios'
import htmx from 'htmx.org'

const client = axios.create({
    headers: {
        'X-CSRF-Token': window.csrfToken
    },
    transformRequest: [
        function(data) {
            return stringify(data)
        },
    ],
})

// Intro
const intro = document.querySelector('[data-intro]');
if (intro) {
    // fade in the intro and show on screen for 3 seconds, then fade out and add negative z-index to hide behind content
    intro.classList.add('opacity-100');
    const introImage = document.querySelector('[data-intro-image]');
    introImage.classList.remove('scale-95');
    introImage.classList.add('scale-100');
    introImage.classList.add('opacity-100');
    setTimeout(() => {
        intro.classList.remove('opacity-100');
        intro.classList.remove('z-30');
        intro.classList.add('opacity-0');
        intro.classList.add('-z-50');
    }, 3000);
    setTimeout(() => {
        intro.classList.add('hidden');
    }, 3701);
    
}

// Get elements
const header = document.querySelector('[data-header]');
const headerActions = document.querySelector('[data-header-actions]');
const headerPhone = document.querySelector('[data-header-phone]');
const menuTrigger = document.querySelector('[data-menu-trigger]');
const menuOverlay = document.querySelector('[data-menu-overlay]');
const menuItems = document.querySelectorAll('[data-menu-item]');
const logoPurple = document.querySelector('img[src="/images/logo-purple.svg"]');
const logoWhite = document.querySelector('img[src="/images/logo-white.svg"]');
const stickySubnav = document.querySelector('[data-sticky-subnav]');

// Initialize variables for scroll tracking
let lastScrollTop = 0;
let isMobile = window.innerWidth <= 768;
let isMenuOpen = false;

// Function to check if at top of page
const isAtTop = () => window.scrollY <= 10;

const setMenuNavSizing = (viewportHeight) => {
    if (!menuOverlay || menuItems.length === 0) return;

    const isNarrow = window.innerWidth <= 767;
    const isShort = viewportHeight <= 760;
    const isCompactHeight = viewportHeight <= 525;
    const itemCount = menuItems.length;
    const logoHeight = isNarrow
        ? (isCompactHeight ? 64 : (viewportHeight <= 700 ? 76 : 92))
        : (isCompactHeight ? 64 : (isShort ? 88 : Math.min(140, Math.max(96, viewportHeight * 0.18))));
    const footerHeight = isCompactHeight ? 50 : (isNarrow ? 74 : 78);
    const mainPadding = isCompactHeight ? 4 : (isNarrow || isShort ? 8 : 20);
    const lineHeight = isCompactHeight ? 1.12 : (isNarrow || isShort ? 1.22 : 1.3);
    const itemGap = isCompactHeight
        ? Math.max(3, Math.min(6, viewportHeight * 0.01))
        : Math.max(isNarrow ? 6 : 8, Math.min(isNarrow ? 12 : 15, viewportHeight * 0.014));
    const availableHeight = viewportHeight - logoHeight - footerHeight - (mainPadding * 2) - (itemGap * (itemCount - 1));
    const fitFontSize = Math.floor(availableHeight / (itemCount * lineHeight));
    const minFontSize = isCompactHeight ? 14 : (isNarrow ? 20 : 24);
    const maxFontSize = isCompactHeight ? Math.max(18, Math.min(isNarrow ? 24 : 28, viewportHeight * 0.05)) : (isNarrow ? 34 : 38);
    const fontSize = Math.max(minFontSize, Math.min(maxFontSize, fitFontSize));

    menuOverlay.style.setProperty('--menu-main-padding-y', `${mainPadding}px`);
    menuOverlay.style.setProperty('--menu-item-gap', `${itemGap}px`);
    menuOverlay.style.setProperty('--menu-link-font-size', `${fontSize}px`);
    menuOverlay.style.setProperty('--menu-link-line-height', lineHeight);
};

const setMenuViewportHeight = () => {
    const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    document.documentElement.style.setProperty('--menu-viewport-height', `${viewportHeight}px`);
    setMenuNavSizing(viewportHeight);
};

// Function to handle initial state
const setInitialState = () => {
if (isMenuOpen) return;

if (isMobile) {
    // Mobile state: initial position is absolute, menu trigger is relative
    header.style.position = 'absolute';
    if (headerActions) headerActions.style.position = 'absolute';
    header.style.backgroundColor = '';
    
    // Reset any inline styles that might have been added
    if (isAtTop()) {
    header.style.backgroundColor = '';
    // Show white logo at top
    if (logoPurple && logoWhite) {
        logoPurple.classList.add('hidden');
        logoWhite.classList.remove('hidden');
    }
    }
    
    // Handle sticky subnav initial state on mobile
    if (stickySubnav) {
    if (isAtTop()) {
        stickySubnav.classList.add('sticky');
        stickySubnav.classList.remove('relative');
    }
    }
} else {
    // Reset for desktop
    header.style.position = 'absolute';
    if (headerActions) headerActions.style.position = 'fixed';
    header.style.backgroundColor = '';
    
    // Restore sticky subnav on desktop
    if (stickySubnav) {
    stickySubnav.classList.add('sticky');
    stickySubnav.classList.remove('relative');
    }
}
};

// Function to toggle menu state
const toggleMenu = (open) => {
isMenuOpen = open;

if (open) {
    menuOverlay.style.opacity = '1';
    menuOverlay.style.maxHeight = '100vh';
    menuOverlay.style.zIndex = '20';
    
    // When menu is open, ensure header has proper styling
    if (isMobile) {
    header.style.position = 'fixed';
    header.style.backgroundColor = '#fff';
    header.style.width = '100%';
    header.style.top = '0';
    toggleLogoVisibility(true); // Show purple logo when menu is open
    
    if (headerPhone) {
        headerPhone.classList.remove('text-white');
        headerPhone.classList.add('text-purple');
    }
    
    // When menu is open, make subnav relative
    if (stickySubnav) {
        stickySubnav.classList.remove('sticky');
        stickySubnav.classList.add('relative');
    }
    }
} else {
    menuOverlay.style.opacity = '0';
    menuOverlay.style.maxHeight = '0';
    menuOverlay.style.zIndex = '-50';
    
    // Reset header state when menu closes
    updateHeaderOnScroll();
}
};

// Function to toggle logo visibility
const toggleLogoVisibility = (isPurpleVisible) => {
if (!logoPurple || !logoWhite) return;

if (isPurpleVisible) {
    // Show purple logo
    logoPurple.classList.remove('hidden');
    logoWhite.classList.add('hidden');
} else {
    // Show white logo
    logoPurple.classList.add('hidden');
    logoWhite.classList.remove('hidden');
}
};

// Function to handle scroll behavior
const updateHeaderOnScroll = () => {
if (!isMobile || isMenuOpen) return;

const scrollTop = window.scrollY;

// At the very top of the page
if (isAtTop()) {
    header.style.position = 'absolute';
    header.style.backgroundColor = '';
    if (headerActions) headerActions.style.position = 'absolute';
    toggleLogoVisibility(false); // Show white logo at top
    
    if (headerPhone) {
        headerPhone.classList.remove('text-purple');
        headerPhone.classList.add('text-white');
    }
    
    // At top, subnav should be sticky
    if (stickySubnav) {
    stickySubnav.classList.add('sticky');
    stickySubnav.classList.remove('relative');
    }
    return;
}

// Scrolling down
if (scrollTop > lastScrollTop) {
    header.style.position = 'absolute';
    if (headerActions) headerActions.style.position = 'absolute';
    header.style.backgroundColor = '';
    toggleLogoVisibility(false); // Show white logo when scrolling down
    
    // When main nav is not visible, subnav can be sticky
    if (stickySubnav) {
    stickySubnav.classList.add('sticky');
    stickySubnav.classList.remove('relative');
    }
} 
// Scrolling up
else {
    header.style.position = 'fixed';
    if (headerActions) headerActions.style.position = 'absolute';
    header.style.backgroundColor = '#fff';
    header.style.top = '0';
    toggleLogoVisibility(true); // Show purple logo when sticky/fixed
    
    if (headerPhone) {
        headerPhone.classList.remove('text-white');
        headerPhone.classList.add('text-purple');
    }
    
    // When main nav is fixed/visible while scrolling up, subnav should be relative
    if (stickySubnav) {
    stickySubnav.classList.remove('sticky');
    stickySubnav.classList.add('relative');
    }
}

lastScrollTop = scrollTop;
};

setMenuViewportHeight();

// Set initial state
setInitialState();

// Event listeners
window.addEventListener('scroll', updateHeaderOnScroll);

window.addEventListener('resize', () => {
isMobile = window.innerWidth <= 768;
setMenuViewportHeight();
setInitialState();
});

if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setMenuViewportHeight);
}

// Handle window load to ensure everything is set correctly
window.addEventListener('load', () => {
    setMenuViewportHeight();
    setInitialState();
});

// Desktop navigation dropdown
const dropdownTrigger = document.querySelector('[data-menu-trigger]');
if (dropdownTrigger) {
        const dropdown = document.querySelector('[data-menu-overlay]');
        if (dropdown) {
            const triggerTop = document.querySelector('[data-menu-trigger-top]');
            const triggerBottom = document.querySelector('[data-menu-trigger-bottom]');
            const header = document.querySelector('[data-header]');
            // Function to disable scrolling
            const disableScroll = () => {
                document.body.style.overflow = 'hidden';
                document.body.style.height = '100%';
            };
            
            // Function to enable scrolling
            const enableScroll = () => {
                document.body.style.overflow = '';
                document.body.style.height = '';
            };
            
            dropdownTrigger.addEventListener('mouseenter', (event) => {
                if (dropdownTrigger.classList.contains('opened')) {
                    triggerTop.classList.remove('rotate-45');
                    triggerBottom.classList.remove('-rotate-45');
                } else {
                    triggerTop.classList.add('-translate-y-[2px]');
                    triggerBottom.classList.add('translate-y-[2px]');
                }
            });
            
            dropdownTrigger.addEventListener('mouseleave', (event) => {
                if (dropdownTrigger.classList.contains('opened')) {
                    triggerTop.classList.add('rotate-45');
                    triggerBottom.classList.add('-rotate-45');
                } else {
                    triggerTop.classList.remove('-translate-y-[2px]');
                    triggerBottom.classList.remove('translate-y-[2px]');
                }
            });
            
            dropdownTrigger.addEventListener('click', (event) => {
                if (dropdownTrigger.classList.contains('opened')) {
                    isMenuOpen = false;
                    dropdownTrigger.setAttribute('aria-expanded', 'false');
                    dropdownTrigger.classList.remove('opened');
                    if (headerActions) {
                        headerActions.classList.remove('z-51');
                        headerActions.classList.add('z-30');
                    }
                    dropdownTrigger.classList.remove('z-51');
                    dropdownTrigger.classList.add('z-30');
                    header.classList.add('z-20');
                    header.classList.remove('z-51');
                    dropdown.classList.remove('z-10');
                    dropdown.classList.add('-z-51');
                    dropdown.classList.add('max-h-0');
                    dropdown.classList.remove('opacity-1');
                    dropdown.classList.add('opacity-0')
                    triggerTop.classList.remove('translate-y-[5px]');
                    triggerBottom.classList.remove('-translate-y-[5px]');
                    triggerTop.classList.remove('rotate-45');
                    triggerBottom.classList.remove('-rotate-45');
                    
                    // Enable scrolling when nav is closed
                    enableScroll();
                    updateHeaderOnScroll();
                } else {
                    isMenuOpen = true;
                    setMenuViewportHeight();
                    dropdownTrigger.setAttribute('aria-expanded', 'true');
                    dropdownTrigger.classList.add('opened');
                    if (headerActions) {
                        headerActions.classList.add('z-51');
                        headerActions.classList.remove('z-30');
                    }
                    dropdownTrigger.classList.add('z-51');
                    dropdownTrigger.classList.remove('z-30');
                    triggerTop.classList.remove('-translate-y-[2px]');
                    triggerBottom.classList.remove('translate-y-[2px]');
                    triggerTop.classList.remove('bg-purple');
                    triggerTop.classList.add('bg-white');
                    triggerBottom.classList.remove('bg-purple');
                    triggerBottom.classList.add('bg-white');
                    if (headerPhone) {
                        headerPhone.classList.remove('text-purple');
                        headerPhone.classList.add('text-white');
                    }
                    header.classList.remove('z-20');
                    header.classList.add('z-51');
                    dropdown.classList.remove('-z-51');
                    dropdown.classList.add('z-10');
                    dropdown.classList.remove('max-h-0');
                    dropdown.classList.remove('opacity-0');
                    dropdown.classList.add('opacity-1');
                    triggerTop.classList.add('translate-y-[5px]');
                    triggerBottom.classList.add('-translate-y-[5px]');
                    triggerTop.classList.add('rotate-45');
                    triggerBottom.classList.add('-rotate-45');
                    
                    // Disable scrolling when nav is open
                    disableScroll();
                }
            });
        }
}

// Shift and fade load-in animations
const elementsToAnimate = document.querySelectorAll('[data-animate="fade-up"]');
const animateObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'scale-100');
            animateObserver.unobserve(entry.target);
        }
    });
}, {
    threshold: 0.5,
});
elementsToAnimate.forEach(element => {
    animateObserver.observe(element);
});

// Fade load-in animations
const elementsToFadeIn = document.querySelectorAll('[data-animate="fade-in"]');
const fadeInObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100');
            fadeInObserver.unobserve(entry.target);
        }
    });
}, {
    threshold: 0.1,
});
elementsToFadeIn.forEach(element => {
    fadeInObserver.observe(element);
});

// Smooth page transitions between internal links only
const links = document.querySelectorAll('a');
const pageScreen = document.querySelector('[data-pagescreen]');
links.forEach(link => {
    link.addEventListener('click', (event) => {
        if (!pageScreen) {
            return;
        }

        // Respect browser default behavior for modified clicks/new tabs/downloads.
        const isModifiedClick = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
        if (isModifiedClick || link.target === '_blank' || link.hasAttribute('download')) {
            return;
        }

        if (link.classList.contains('link-external')) {
            return;
        }

        const href = link.getAttribute('href') || '';
        if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) {
            return;
        }

        if (link.origin !== window.location.origin) {
            return;
        }

        event.preventDefault();
        const url = link.href;
        pageScreen.classList.add('opacity-100');
        pageScreen.classList.remove('h-0');
        pageScreen.classList.add('h-[100vh]');
        setTimeout(() => {
            window.location.href = url;
            pageScreen.classList.add('opacity-0');
        }, 1200);
    });
});


// on page load fade in the body opacity
const pageIntro = document.querySelector('[data-pageintro]');
pageIntro.classList.remove('opacity-100');
pageIntro.classList.add('opacity-0');
pageIntro.classList.remove('z-50');
setTimeout(() => {
    pageIntro.classList.add('-z-50');
}, 701);


// Detect contrast for hamburger
const menuTriggerTop = document.querySelector('[data-menu-trigger-top]');
const menuTriggerBottom = document.querySelector('[data-menu-trigger-bottom]');
const components = document.querySelectorAll('[data-component]');
if (menuTrigger && menuTriggerTop && menuTriggerBottom && components.length !== 0) {
  
  // Function to determine if a component needs dark contrast
  function needsDarkContrast(element) {
    // Hero image with sky likely needs dark menu (purple)
    if (element.classList.contains('hero') || 
        element.hasAttribute('data-hero') || 
        (element.querySelector('img') && element.querySelector('img').src.includes('arealview'))) {
      return true;
    }
    
    // Check for component-specific contrast setting
    if (element.hasAttribute('data-contrast')) {
      return element.getAttribute('data-contrast') === 'dark';
    }
    
    // Calculate if background is light or dark
    const hasBgImage = element.querySelector('img') !== null;
    const hasDarkBg = element.classList.contains('bg-purple') || 
                      element.classList.contains('bg-dark') || 
                      element.classList.contains('bg-black');
    
    // For images, check if it's a light image (like sky, etc)
    if (hasBgImage) {
      const images = element.querySelectorAll('img');
      for (const img of images) {
        // Look for images that likely have light backgrounds
        if (img.src.includes('sky') || 
            img.src.includes('hero') || 
            img.src.includes('aerial') || 
            img.src.includes('view') ||
            img.alt.toLowerCase().includes('sky')) {
          return true; // Need dark menu for light backgrounds
        }
      }
      
      // Default for other images - use light menu (white)
      return false;
    }
    
    // For sections with dark background classes, use light menu (white)
    if (hasDarkBg) {
      return false;
    }
    
    // Default to dark menu for light backgrounds
    return true;
  }
  
  // Function to update menu trigger color
  function updateMenuTriggerColor(isDark) {
    // Check if navigation is opened - if so, don't change colors
    if (menuTrigger.classList.contains('opened')) {
      return;
    }
    
    if (isDark) {
      // Light contrast - light menu on dark background
      menuTriggerTop.classList.remove('bg-purple');
      menuTriggerBottom.classList.remove('bg-purple');
      menuTriggerTop.classList.add('bg-white');
      menuTriggerBottom.classList.add('bg-white');
      if (headerPhone) {
        headerPhone.classList.remove('text-purple');
        headerPhone.classList.add('text-white');
      }
    } else {
      // Dark contrast - dark menu on light background
      menuTriggerTop.classList.remove('bg-white');
      menuTriggerBottom.classList.remove('bg-white');
      menuTriggerTop.classList.add('bg-purple');
      menuTriggerBottom.classList.add('bg-purple');
      if (headerPhone) {
        headerPhone.classList.remove('text-white');
        headerPhone.classList.add('text-purple');
      }
    }
  }
  
  // Function to check if menu overlaps with a component
  function isMenuOverlappingComponent(component) {
    const menuRect = (headerActions || menuTrigger).getBoundingClientRect();
    const componentRect = component.getBoundingClientRect();
    
    // Check exact overlap with menu
    return (
      menuRect.left < componentRect.right &&
      menuRect.right > componentRect.left &&
      menuRect.top < componentRect.bottom &&
      menuRect.bottom > componentRect.top
    );
  }
  
  // Function to find which component is currently behind the menu
  function findComponentBehindMenu() {
    // Get all potential components
    const allComponents = [...document.querySelectorAll('[data-component], .hero, [data-hero], section, .w-full')];
    
    // Sort by z-index (higher z-index first)
    allComponents.sort((a, b) => {
      const zIndexA = parseInt(getComputedStyle(a).zIndex) || 0;
      const zIndexB = parseInt(getComputedStyle(b).zIndex) || 0;
      return zIndexB - zIndexA;
    });
    
    // Find the topmost component that overlaps with the menu
    for (const component of allComponents) {
      if (isMenuOverlappingComponent(component) && getComputedStyle(component).display !== 'none') {
        return component;
      }
    }
    
    return null;
  }
  
  // Function to check what's behind the menu and update colors accordingly
  function updateMenuColors() {
    // Skip color updates if menu is opened
    if (menuTrigger.classList.contains('opened')) {
      return;
    }
    
    const component = findComponentBehindMenu();
    if (component) {
      const isDark = needsDarkContrast(component);
      updateMenuTriggerColor(isDark);
    }
  }
  
  // Use requestAnimationFrame for smoother performance during scroll
  let ticking = false;
  
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        updateMenuColors();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
  
  // Also check on resize
  window.addEventListener('resize', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        updateMenuColors();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
  
  // Initial check
  updateMenuColors();
};

// Hero scroll down button
const heroElement = document.querySelector('[data-hero]');
const scrollDownButton = document.querySelector('[data-scroll-down-button]');

if (heroElement || scrollDownButton) {

    // Initialize button as hidden
    scrollDownButton.style.opacity = '0';
    scrollDownButton.style.transition = 'opacity 0.3s ease';

    // Set up intersection observer to detect when hero is in viewport
    const heroObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
        // Hero is in viewport, show button
        scrollDownButton.style.opacity = '1';
        } else {
        // Hero is out of viewport, hide button
        scrollDownButton.style.opacity = '0';
        }
    });
    }, { threshold: 0.1 }); // Trigger when at least 10% of hero is visible

    // Start observing the hero element
    heroObserver.observe(heroElement);

    // Track scroll direction
    let lastScrollTop = 0;

    // Add scroll event listener to handle button visibility based on scroll direction
    window.addEventListener('scroll', function() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Check if hero is in viewport (rough check)
    const heroRect = heroElement.getBoundingClientRect();
    const isHeroVisible = heroRect.bottom > 0 && heroRect.top < window.innerHeight;

    if (isHeroVisible) {
        // Detect scroll direction
        if (scrollTop > lastScrollTop) {
        // Scrolling down, hide button
        scrollDownButton.style.opacity = '0';
        } else {
        // Scrolling up, show button
        scrollDownButton.style.opacity = '1';
        }
    }

    lastScrollTop = scrollTop;
    });

    // Handle scroll button click
    scrollDownButton.addEventListener('click', function() {
    // Calculate position to scroll to (just past the hero)
    const heroRect = heroElement.getBoundingClientRect();
    const scrollToPosition = window.pageYOffset + heroRect.bottom;

    // Smooth scroll to position
    window.scrollTo({
        top: scrollToPosition,
        behavior: 'smooth'
    });
    });
}

// Image slideshows
const imageSliders = document.querySelectorAll('[data-slider]');
const captionSliders = document.querySelectorAll('[data-captions]');

if (imageSliders.length && captionSliders.length) {
    // Initialize arrays to store slider instances
    const sliderInstances = [];
    const captionInstances = [];

    // Initialize image sliders
    imageSliders.forEach((swiperEl, index) => {
        const paginationEl = swiperEl.querySelector('[data-swiper-pagination]');
        const hasTextLabels = paginationEl && paginationEl.hasAttribute('data-swiper-pagination-labels');
        const shouldAutoplay = swiperEl.hasAttribute('data-autoplay');
        const triggerButton = swiperEl.querySelector('[data-slideshow-trigger]');
        const isMobile = () => window.innerWidth <= 768;
        
        // Configure pagination based on whether text labels are needed
        let paginationConfig = {
            el: paginationEl,
            clickable: true,
            bulletClass: 'pagination-block',
            bulletActiveClass: 'pagination-block-active'
        };
        
        // If text labels are needed, customize the pagination bullets
        if (hasTextLabels) {
            // Get all slides to extract their labels
            const slides = swiperEl.querySelectorAll('.swiper-slide');
            const labels = Array.from(slides).map(slide => slide.getAttribute('data-label') || '');
            
            // Custom render function for bullets with text
            paginationConfig.renderBullet = function(index, className) {
                const label = labels[index] || '';
                return `<div class="${className}"><span>${label}</span></div>`;
            };
        }
        
        // Configure autoplay based on data attribute
        const autoplayConfig = shouldAutoplay ? {
            delay: 5000,
            disableOnInteraction: false
        } : false;

        const imageSlider = new Swiper(swiperEl, {
            slidesPerView: 1,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            spaceBetween: 0,
            navigation: {
                nextEl: swiperEl.querySelector('[data-swiper-button-next]'),
                prevEl: swiperEl.querySelector('[data-swiper-button-prev]'),
            },
            autoplay: autoplayConfig,
            pagination: paginationConfig,
            // Add responsive breakpoints
            breakpoints: {
                // When window width is <= 768px
                768: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    // Adjust the height to fit viewport on mobile
                    autoHeight: false,
                    // Ensure slide content is centered and fits viewport
                    centeredSlides: false,                    
                },
                // When window width is > 768px
                769: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    autoHeight: true,
                    // Ensure slide content is centered and fits viewport
                    centeredSlides: false
                }
            },
            // For mobile, ensure slides respond to viewport
            on: {
                resize: function() {
                    // Check if mobile viewport
                    if (window.innerWidth <= 768) {
                        // Adjust slide height to fit viewport on resize
                        const slides = this.slides;
                        const viewportHeight = window.innerHeight;
                        const headerHeight = document.querySelector('[data-header]') ? 
                            document.querySelector('[data-header]').offsetHeight : 0;
                        
                        // Calculate max height (subtract header and any other fixed elements)
                        const maxHeight = viewportHeight - headerHeight - 60; // 60px buffer
                        
                        // Apply max height to slides
                        slides.forEach(slide => {
                            slide.style.maxHeight = `${maxHeight}px`;
                            slide.style.height = 'auto';
                        });
                        
                        // Update swiper to recalculate dimensions
                        this.update();
                    } else {
                        // Reset styles for desktop
                        const slides = this.slides;
                        slides.forEach(slide => {
                            slide.style.maxHeight = '';
                            slide.style.height = '';
                        });
                        this.update();
                    }
                }
            }
        });
        sliderInstances.push(imageSlider);
        
        // Trigger resize handler on init to apply correct sizing
        imageSlider.on('init', function() {
            // Trigger the resize handler to set initial sizes
            this.emit('resize');
        });

        // Add click event to slides to advance to next slide
        const slides = swiperEl.querySelectorAll('.swiper-slide');
        slides.forEach(slide => {
            slide.style.cursor = 'pointer'; // Add pointer cursor to indicate clickable
            slide.addEventListener('click', function(e) {
                // Check if click was on a button or link inside the slide
                const isClickableElement = e.target.closest('a, button, [data-clickable]');
                if (!isClickableElement) {
                    imageSlider.slideNext();
                }
            });
        });

        // Mobile pagination toggle functionality
        if (triggerButton && paginationEl) {
            // Function to update trigger button text
            const updateTriggerText = () => {
                if (!isMobile() || !triggerButton) return;
                
                const activeIndex = imageSlider.realIndex;
                const activeSlide = slides[activeIndex];
                
                if (activeSlide) {
                    const label = activeSlide.getAttribute('data-label');
                    if (label) {
                        const buttonSpan = triggerButton.querySelector('span');
                        if (buttonSpan) {
                            buttonSpan.textContent = label;
                        }
                    }
                }
            };
            
            // Initialize mobile state
            const initMobileState = () => {
                if (isMobile()) {
                    // Hide pagination by default on mobile
                    if (paginationEl) {
                        paginationEl.style.display = 'none';
                    }
                    
                    // Update trigger text
                    updateTriggerText();
                } else {
                    // Always show pagination on desktop
                    if (paginationEl) {
                        paginationEl.style.display = '';
                    }
                }
            };
            
            // Add click event to trigger button
            triggerButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation(); // Stop click event from propagating to document
                
                if (!isMobile()) return;
                
                // Toggle the pagination display
                if (paginationEl.style.display === 'none') {
                    paginationEl.style.display = 'flex';
                    const caretIcon = triggerButton.querySelector('.icon-carat-down');
                    if (caretIcon) {
                        caretIcon.style.transform = 'rotate(180deg)';
                    }
                } else {
                    paginationEl.style.display = 'none';
                    const caretIcon = triggerButton.querySelector('.icon-carat-down');
                    if (caretIcon) {
                        caretIcon.style.transform = '';
                    }
                }
            });
            
            // Update button text on slide change
            imageSlider.on('slideChange', () => {
                updateTriggerText();
            });
            
            // Handle pagination bullet clicks
            if (paginationEl) {
                paginationEl.addEventListener('click', (e) => {
                    // Only close if the click was on a bullet, not just anywhere in the pagination container
                    const clickedBullet = e.target.closest('.pagination-block');
                    if (clickedBullet && isMobile()) {
                        setTimeout(() => {
                            paginationEl.style.display = 'none';
                            const caretIcon = triggerButton.querySelector('.icon-carat-down');
                            if (caretIcon) {
                                caretIcon.style.transform = '';
                            }
                        }, 300);
                    }
                });
            }
            
            // Add a document click handler to close the dropdown when clicking outside
            document.addEventListener('click', (e) => {
                if (!isMobile() || !paginationEl || paginationEl.style.display === 'none') return;
                
                // Check if the click was outside both the pagination and the trigger button
                if (!paginationEl.contains(e.target) && !triggerButton.contains(e.target)) {
                    paginationEl.style.display = 'none';
                    const caretIcon = triggerButton.querySelector('.icon-carat-down');
                    if (caretIcon) {
                        caretIcon.style.transform = '';
                    }
                }
            });
            
            // Initialize mobile state
            initMobileState();
            
            // Update on window resize
            window.addEventListener('resize', initMobileState);
        }

        // Initialize corresponding caption slider
        if (captionSliders[index]) {
            const captionSlider = new Swiper(captionSliders[index], {
                slidesPerView: 1,
                effect: "fade",
                fadeEffect: {
                    crossFade: true
                },
                loop: true,
                spaceBetween: 0,
                allowTouchMove: false, // Disable touch interaction on captions
                autoplay: false // Never autoplay captions independently
            });
            captionInstances.push(captionSlider);

            // Make caption slides clickable too
            const captionSlides = captionSliders[index].querySelectorAll('.swiper-slide');
            captionSlides.forEach(slide => {
                slide.style.cursor = 'pointer';
                slide.addEventListener('click', function(e) {
                    const isClickableElement = e.target.closest('a, button, [data-clickable]');
                    if (!isClickableElement) {
                        imageSlider.slideNext();
                    }
                });
            });

            // Sync the sliders
            imageSlider.on('slideChange', () => {
                captionSlider.slideTo(imageSlider.realIndex);
            });

            // Handle autoplay sync if needed
            if (shouldAutoplay) {
                imageSlider.on('autoplayStart', () => {
                    captionSlider.slideTo(imageSlider.realIndex);
                });

                imageSlider.on('autoplayStop', () => {
                    // Nothing needed here as captions don't have independent autoplay
                });
            }
        }
    });
} else if (imageSliders.length) {
    // Initialize arrays to store slider instances
    const sliderInstances = [];

    // Initialize image sliders
    imageSliders.forEach((swiperEl, index) => {
        const paginationEl = swiperEl.querySelector('[data-swiper-pagination]');
        const hasTextLabels = paginationEl && paginationEl.hasAttribute('data-swiper-pagination-labels');
        const shouldAutoplay = swiperEl.hasAttribute('data-autoplay');
        const triggerButton = swiperEl.querySelector('[data-slideshow-trigger]');
        const isMobile = () => window.innerWidth <= 768;
        
        // Configure pagination based on whether text labels are needed
        let paginationConfig = {
            el: paginationEl,
            clickable: true,
            bulletClass: 'pagination-block',
            bulletActiveClass: 'pagination-block-active'
        };
        
        // If text labels are needed, customize the pagination bullets
        if (hasTextLabels) {
            // Get all slides to extract their labels
            const slides = swiperEl.querySelectorAll('.swiper-slide');
            const labels = Array.from(slides).map(slide => slide.getAttribute('data-label') || '');
            
            // Custom render function for bullets with text
            paginationConfig.renderBullet = function(index, className) {
                const label = labels[index] || '';
                return `<div class="${className}"><span>${label}</span></div>`;
            };
        }
        
        // Configure autoplay based on data attribute
        const autoplayConfig = shouldAutoplay ? {
            delay: 5000,
            disableOnInteraction: false
        } : false;

        const imageSlider = new Swiper(swiperEl, {
            slidesPerView: 1,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            spaceBetween: 0,
            navigation: {
                nextEl: swiperEl.querySelector('[data-swiper-button-next]'),
                prevEl: swiperEl.querySelector('[data-swiper-button-prev]'),
            },
            autoplay: autoplayConfig,
            pagination: paginationConfig,
            // Add responsive breakpoints
            breakpoints: {
                // When window width is <= 768px
                768: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    // Adjust the height to fit viewport on mobile
                    autoHeight: true,
                    // Ensure slide content is centered and fits viewport
                    centeredSlides: true
                },
                // When window width is > 768px
                769: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    autoHeight: false,
                    centeredSlides: false
                }
            },
            // For mobile, ensure slides respond to viewport
            on: {
                resize: function() {
                    // Check if mobile viewport
                    if (window.innerWidth <= 768) {
                        // Adjust slide height to fit viewport on resize
                        const slides = this.slides;
                        const viewportHeight = window.innerHeight;
                        const headerHeight = document.querySelector('[data-header]') ? 
                            document.querySelector('[data-header]').offsetHeight : 0;
                        
                        // Calculate max height (subtract header and any other fixed elements)
                        const maxHeight = viewportHeight - headerHeight - 60; // 60px buffer
                        
                        // Apply max height to slides
                        slides.forEach(slide => {
                            slide.style.maxHeight = `${maxHeight}px`;
                            slide.style.height = 'auto';
                        });
                        
                        // Update swiper to recalculate dimensions
                        this.update();
                    } else {
                        // Reset styles for desktop
                        const slides = this.slides;
                        slides.forEach(slide => {
                            slide.style.maxHeight = '';
                            slide.style.height = '';
                        });
                        this.update();
                    }
                }
            }
        });
        sliderInstances.push(imageSlider);
        
        // Trigger resize handler on init to apply correct sizing
        imageSlider.on('init', function() {
            // Trigger the resize handler to set initial sizes
            this.emit('resize');
        });

        // Add click event to slides to advance to next slide
        const slides = swiperEl.querySelectorAll('.swiper-slide');
        slides.forEach(slide => {
            slide.style.cursor = 'pointer'; // Add pointer cursor to indicate clickable
            slide.addEventListener('click', function(e) {
                // Check if click was on a button or link inside the slide
                const isClickableElement = e.target.closest('a, button, [data-clickable]');
                if (!isClickableElement) {
                    imageSlider.slideNext();
                }
            });
        });
        
        // Mobile pagination toggle functionality
        if (triggerButton && paginationEl) {
            // Function to update trigger button text
            const updateTriggerText = () => {
                if (!isMobile() || !triggerButton) return;
                
                const activeIndex = imageSlider.realIndex;
                const activeSlide = slides[activeIndex];
                
                if (activeSlide) {
                    const label = activeSlide.getAttribute('data-label');
                    if (label) {
                        const buttonSpan = triggerButton.querySelector('span');
                        if (buttonSpan) {
                            buttonSpan.textContent = label;
                        }
                    }
                }
            };
            
            // Initialize mobile state
            const initMobileState = () => {
                if (isMobile()) {
                    // Hide pagination by default on mobile
                    if (paginationEl) {
                        paginationEl.style.display = 'none';
                    }
                    
                    // Update trigger text
                    updateTriggerText();
                } else {
                    // Always show pagination on desktop
                    if (paginationEl) {
                        paginationEl.style.display = '';
                    }
                }
            };
            
            // Add click event to trigger button
            triggerButton.addEventListener('click', (e) => {
                e.preventDefault();
                
                if (!isMobile()) return;
                
                // Toggle the pagination display
                if (paginationEl.style.display === 'none') {
                    paginationEl.style.display = 'flex';
                    const caretIcon = triggerButton.querySelector('.icon-carat-down');
                    if (caretIcon) {
                        caretIcon.style.transform = 'rotate(180deg)';
                    }
                } else {
                    paginationEl.style.display = 'none';
                    const caretIcon = triggerButton.querySelector('.icon-carat-down');
                    if (caretIcon) {
                        caretIcon.style.transform = '';
                    }
                }
            });
            
            // Update button text on slide change
            imageSlider.on('slideChange', () => {
                updateTriggerText();
                
                // If on mobile and pagination is open, close it after slide change
                if (isMobile() && paginationEl && paginationEl.style.display !== 'none') {
                    setTimeout(() => {
                        paginationEl.style.display = 'none';
                        const caretIcon = triggerButton.querySelector('.icon-carat-down');
                        if (caretIcon) {
                            caretIcon.style.transform = '';
                        }
                    }, 300);
                }
            });
            
            // Handle pagination bullet clicks
            if (paginationEl) {
                paginationEl.addEventListener('click', (e) => {
                    // Close pagination after a short delay to allow for slide change
                    if (isMobile()) {
                        setTimeout(() => {
                            paginationEl.style.display = 'none';
                            const caretIcon = triggerButton.querySelector('.icon-carat-down');
                            if (caretIcon) {
                                caretIcon.style.transform = '';
                            }
                        }, 300);
                    }
                });
            }
            
            // Initialize mobile state
            initMobileState();
            
            // Update on window resize
            window.addEventListener('resize', initMobileState);
        }
    });
}

// Collapse functionality
const collapseTriggers = document.querySelectorAll('[data-collapse-trigger]');
if (collapseTriggers.length) {
    collapseTriggers.forEach(trigger => {
        const content = trigger.previousElementSibling;
        if (content && content.hasAttribute('data-collapse-contents')) {
            // Store original text
            const originalText = trigger.textContent;
            
            trigger.addEventListener('click', () => {
                if (content.classList.contains('max-h-0')) {
                    // Open the content
                    content.style.maxHeight = `${content.scrollHeight}px`;
                    content.classList.remove('max-h-0');
                    trigger.textContent = 'Close';
                } else {
                    // Close the content
                    content.style.maxHeight = '0px';
                    content.classList.add('max-h-0');
                    trigger.textContent = originalText;
                }
            });
        }
    });
}

// Filter dropdown functionality
const filterTriggers = document.querySelectorAll('[data-filter-trigger]');

if (filterTriggers.length) {
    // Helper function to check if viewport is mobile
    const isMobile = () => window.innerWidth <= 768;
    
    // Helper to close all dropdowns
    const closeAllDropdowns = () => {
        document.querySelectorAll('[data-filter-options]').forEach(dropdown => {
            dropdown.classList.add('hidden');
        });
        document.querySelectorAll('[data-filter-trigger] .icon-carat-down').forEach(icon => {
            icon.classList.remove('rotate-180');
            icon.classList.remove('translate-y-[3px]');
        });
    };
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', (event) => {
        if (!event.target.closest('[data-filter-trigger]') && 
            !event.target.closest('[data-filter-options]')) {
            closeAllDropdowns();
        }
    });
    
    // Initialize dropdowns
    const initializeDropdowns = () => {
        // Move querySelector inside the initialization function
        const filterTriggers = document.querySelectorAll('[data-filter-trigger]');
        
        filterTriggers.forEach(trigger => {
            const filterType = trigger.getAttribute('data-filter');
            const dropdown = document.querySelector(`[data-filter-options][data-filter="${filterType}"]`);
            const icon = trigger.querySelector('.icon-carat-down');
            const labelSpan = trigger.querySelector('span'); // Span acting as label
            
            if (dropdown) {
                // Handle trigger click
                trigger.addEventListener('click', (event) => {
                    event.stopPropagation();
                    
                    const isCurrentlyHidden = dropdown.classList.contains('hidden');
                    
                    // Close all other dropdowns first
                    closeAllDropdowns();
                    
                    if (isCurrentlyHidden) {
                        // Open this dropdown
                        dropdown.classList.remove('hidden');
                        icon.classList.add('rotate-180');
                        icon.classList.add('translate-y-[3px]'); // Add translateY to caret
                    }
                });
                
                // Handle option selection
                const options = dropdown.querySelectorAll('[data-filter-option]');
                options.forEach(option => {
                    option.addEventListener('click', () => {
                        // Remove active class from all options
                        options.forEach(opt => opt.classList.remove('active'));
                        
                        // Add active class to selected option
                        option.classList.add('active');
                        
                        // Only update the trigger label on desktop
                        if (!isMobile() && labelSpan) {
                            labelSpan.textContent = option.textContent.trim();
                        }
                        
                        // Only close dropdown after selection on desktop
                        if (!isMobile()) {
                            // Add a small delay to allow HTMX to process
                            setTimeout(() => {
                                // Close dropdown after selection
                                dropdown.classList.add('hidden');
                                icon.classList.remove('rotate-180');
                                icon.classList.remove('translate-y-[3px]');
                            }, 100);
                        }
                    });
                });
                
            }
        });
    };
    
    const initializeViewToggle = () => {
        const gridTrigger = document.querySelector('[data-grid-trigger]');
        if (gridTrigger) {
            const table = document.querySelector('[data-table]');
            const grid = document.querySelector('[data-grid]');
            
            const updateView = () => {
                const isGridView = !grid.classList.contains('hidden');
                
                // Update button text
                gridTrigger.textContent = isGridView ? 'Grid View' : 'List View';
                
                // Toggle visibility
                if (isGridView) {
                    table.classList.remove('hidden');
                    grid.classList.add('hidden');
                } else {
                    table.classList.add('hidden');
                    grid.classList.remove('hidden');
                }
            };
            
            gridTrigger.addEventListener('click', () => {
                updateView();
            });
        }
    };
    
    // Handle window resize events to update UI if needed
    window.addEventListener('resize', () => {
        // Refresh dropdown behavior if crossing the mobile/desktop threshold
        const dropdowns = document.querySelectorAll('[data-filter-options]');
        
        dropdowns.forEach(dropdown => {
            // Toggle close button visibility based on viewport
            const closeButton = dropdown.querySelector('.mobile-close-btn');
            if (closeButton) {
                closeButton.style.display = isMobile() ? 'block' : 'none';
            }
        });
    });
    
    // Initial setup
    initializeViewToggle();
    
    // Initial setup
    initializeDropdowns();
    
    // Re-initialize after HTMX swaps
    htmx.on('htmx:afterSwap', function(event) {
        initializeDropdowns();
        initializeViewToggle();
    });
}

// when clicking on data-hide-footer, add a cookie "footer-collapsed" with value "true"
const hideFooter = document.querySelector('[data-hide-footer]');
if (hideFooter) {
    hideFooter.addEventListener('click', () => {
        document.cookie = "footer-collapsed=true; path=/";
        // also remove the sticky class on the element "data-footer-bar" and replace with a "relative" class
        const footerBar = document.querySelector('[data-footer-bar]');
        footerBar.classList.remove('sticky');
        footerBar.classList.remove('md:sticky');
        footerBar.classList.remove('md:bottom-0');
        footerBar.classList.add('relative');
        // then hide the button
        hideFooter.classList.add('hidden');
    });
}

class DraggableMap {
    constructor(mapImageElement, mapDragElement, options = {}) {
      this.mapImage = mapImageElement;
      this.mapDrag = mapDragElement;
      this.options = {
        dragResistance: options.dragResistance || 0.3,
        edgeResistance: options.edgeResistance || 0.9,
        initialX: options.initialX || -190,
        initialY: options.initialY || -50,
        ...options
      };
      
      this.isDragging = false;
      this.currentX = this.options.initialX;
      this.currentY = this.options.initialY;
      this.startX = 0;
      this.startY = 0;
      this.velocityX = 0;
      this.velocityY = 0;
      this.lastTimeStamp = 0;
      this.lastX = 0;
      this.lastY = 0;
      this.isDesktop = window.innerWidth >= 1024; // Track desktop state
      
      this.init();
    }
  
    init() {
      // Set initial position
      this.setPosition(this.options.initialX, this.options.initialY);
      
      // Add event listeners
      this.mapImage.addEventListener('mousedown', this.onDragStart.bind(this));
      this.mapImage.addEventListener('touchstart', this.onDragStart.bind(this));
      window.addEventListener('mousemove', this.onDragMove.bind(this));
      window.addEventListener('touchmove', this.onDragMove.bind(this));
      window.addEventListener('mouseup', this.onDragEnd.bind(this));
      window.addEventListener('touchend', this.onDragEnd.bind(this));
      
      // Add resize listener
      window.addEventListener('resize', this.handleResize.bind(this));
    }
  
    handleResize() {
      const wasDesktop = this.isDesktop;
      this.isDesktop = window.innerWidth >= 1024;
      
      // If switching between mobile and desktop, reset position
      if (wasDesktop !== this.isDesktop) {
        this.setPosition(
          this.isDesktop ? 0 : this.options.initialX,
          this.isDesktop ? this.currentY : this.options.initialY
        );
      }
    }
  
    setPosition(x, y) {
      // Get bounds
      const bounds = this.getBounds();
      
      // On desktop, lock X position to 0
      if (this.isDesktop) {
        x = 0;
      } else {
        // Apply edge resistance for X on mobile only
        if (x < bounds.left) {
          x = bounds.left + (x - bounds.left) * this.options.edgeResistance;
        } else if (x > bounds.right) {
          x = bounds.right + (x - bounds.right) * this.options.edgeResistance;
        }
      }
      
      // Apply edge resistance for Y on both desktop and mobile
      if (y < bounds.top) {
        y = bounds.top + (y - bounds.top) * this.options.edgeResistance;
      } else if (y > bounds.bottom) {
        y = bounds.bottom + (y - bounds.bottom) * this.options.edgeResistance;
      }
      
      // Apply position
      this.mapImage.style.transform = `translate(${x}px, ${y}px)`;
      this.currentX = x;
      this.currentY = y;
    }
  
    getBounds() {
      const dragRect = this.mapDrag.getBoundingClientRect();
      const imageRect = this.mapImage.getBoundingClientRect();
      
      return {
        left: dragRect.width - imageRect.width,
        right: 0,
        top: dragRect.height - imageRect.height,
        bottom: 0
      };
    }
  
    onDragStart(e) {
      if (e.type === 'touchstart') {
        e.preventDefault();
      }
      
      this.isDragging = true;
      this.startX = (e.type === 'mousedown' ? e.clientX : e.touches[0].clientX) - this.currentX;
      this.startY = (e.type === 'mousedown' ? e.clientY : e.touches[0].clientY) - this.currentY;
      this.lastTimeStamp = Date.now();
      this.lastX = this.currentX;
      this.lastY = this.currentY;
    }
  
    onDragMove(e) {
      if (!this.isDragging) return;
      
      e.preventDefault();
      
      const currentTime = Date.now();
      const deltaTime = currentTime - this.lastTimeStamp;
      
      const clientX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
      const clientY = e.type === 'mousemove' ? e.clientY : e.touches[0].clientY;
      
      // Calculate new position
      let x = clientX - this.startX;
      let y = clientY - this.startY;
      
      // If desktop, don't update X position
      if (this.isDesktop) {
        x = 0;
      }
      
      // Apply drag resistance
      x *= (1 - this.options.dragResistance);
      y *= (1 - this.options.dragResistance);
      
      // Calculate velocity
      if (deltaTime > 0) {
        this.velocityX = this.isDesktop ? 0 : (x - this.lastX) / deltaTime;
        this.velocityY = (y - this.lastY) / deltaTime;
      }
      
      this.setPosition(x, y);
      
      this.lastTimeStamp = currentTime;
      this.lastX = x;
      this.lastY = y;
    }
  
    onDragEnd() {
      if (!this.isDragging) return;
      
      this.isDragging = false;
      
      // Apply inertia only if we have significant velocity
      if (Math.abs(this.velocityY) > 0.1 || (!this.isDesktop && Math.abs(this.velocityX) > 0.1)) {
        this.applyInertia();
      }
    }
  
    applyInertia() {
      const decay = 0.95;
      const minVelocity = 0.01;
      
      const animate = () => {
        if (Math.abs(this.velocityX) < minVelocity && Math.abs(this.velocityY) < minVelocity) {
          return;
        }
        
        // Don't apply horizontal inertia on desktop
        const newX = this.isDesktop ? 0 : this.currentX + this.velocityX * 16;
        const newY = this.currentY + this.velocityY * 16;
        
        this.setPosition(newX, newY);
        
        // Decay velocities
        this.velocityX *= decay;
        this.velocityY *= decay;
        
        requestAnimationFrame(animate);
      };
      
      requestAnimationFrame(animate);
    }
  
    destroy() {
      // Remove event listeners
      this.mapImage.removeEventListener('mousedown', this.onDragStart);
      this.mapImage.removeEventListener('touchstart', this.onDragStart);
      window.removeEventListener('mousemove', this.onDragMove);
      window.removeEventListener('touchmove', this.onDragMove);
      window.removeEventListener('mouseup', this.onDragEnd);
      window.removeEventListener('touchend', this.onDragEnd);
      window.removeEventListener('resize', this.handleResize);
    }
}

class MapInteractions {
    constructor() {
      // Store references to all map icons and buttons
      this.mapIcons = document.querySelectorAll('[data-map-icon]');
      this.listButtons = document.querySelectorAll('button[data-map-icon]');
      
      // Keep track of current active elements
      this.activeIconId = null;
      
      // Bind event handlers
      this.handleIconHover = this.handleIconHover.bind(this);
      this.handleIconClick = this.handleIconClick.bind(this);
      this.handleButtonHover = this.handleButtonHover.bind(this);
      this.handleButtonClick = this.handleButtonClick.bind(this);
      
      this.init();
    }
    
    init() {
      // Add event listeners to map icons
      this.mapIcons.forEach(iconGroup => {
        const iconId = iconGroup.getAttribute('data-map-icon');
        const iconDot = iconGroup.querySelector('div'); // The black dot element
        const iconLabel = iconGroup.querySelector('span'); // The label element
        
        // Add hover events to the icon group
        iconGroup.addEventListener('mouseenter', () => this.handleIconHover(iconId, true));
        iconGroup.addEventListener('mouseleave', () => this.handleIconHover(iconId, false));
        
        // Add click event to the dot
        if (iconDot) {
            iconDot.addEventListener('click', () => this.handleIconClick(iconId));
        }
      });
      
      // Add event listeners to list buttons
      this.listButtons.forEach(button => {
        const buttonId = button.getAttribute('data-map-icon');
        
        button.addEventListener('mouseenter', () => this.handleButtonHover(buttonId, true));
        button.addEventListener('mouseleave', () => this.handleButtonHover(buttonId, false));
        button.addEventListener('click', () => this.handleButtonClick(buttonId));
      });
    }
    
    handleIconHover(iconId, isEntering) {
      const iconGroup = document.querySelector(`[data-map-icon="${iconId}"]`);
      const button = document.querySelector(`button[data-map-icon="${iconId}"]`);
      const label = iconGroup.querySelector('span');
      
      if (isEntering) {
        // Show icon label and highlight button
        label.style.opacity = '1';
        button.classList.add('is-active');
        
        // Add after element for vertical line
        label.style.setProperty('--after-height', '20px');
      } else {
        // Only hide/remove if this isn't the active icon
        if (this.activeIconId !== iconId) {
          label.style.opacity = '0';
          button.classList.remove('is-active');
          label.style.setProperty('--after-height', '0px');
        }
      }
    }
    
    handleIconClick(iconId) {
      this.toggleActive(iconId);
    }
    
    handleButtonHover(buttonId, isEntering) {
      const iconGroup = document.querySelector(`[data-map-icon="${buttonId}"]`);
      const button = document.querySelector(`button[data-map-icon="${buttonId}"]`);
      const label = iconGroup.querySelector('span');
      
      if (isEntering) {
        // Show icon label and highlight button
        label.style.opacity = '1';
        button.classList.add('is-active');
        label.style.setProperty('--after-height', '20px');
      } else {
        // Only hide/remove if this isn't the active button
        if (this.activeIconId !== buttonId) {
          label.style.opacity = '0';
          button.classList.remove('is-active');
          label.style.setProperty('--after-height', '0px');
        }
      }
    }
    
    handleButtonClick(buttonId) {
      this.toggleActive(buttonId);
    }
    
    toggleActive(id) {
      // Remove active state from previous elements
      if (this.activeIconId) {
        const prevIconGroup = document.querySelector(`[data-map-icon="${this.activeIconId}"]`);
        const prevButton = document.querySelector(`button[data-map-icon="${this.activeIconId}"]`);
        const prevLabel = prevIconGroup.querySelector('span');
        
        prevLabel.style.opacity = '0';
        prevButton.classList.remove('is-active');
        prevLabel.style.setProperty('--after-height', '0px');
      }
      
      // If clicking the same element, just clear the active state
      if (this.activeIconId === id) {
        this.activeIconId = null;
        return;
      }
      
      // Set new active elements
      const newIconGroup = document.querySelector(`[data-map-icon="${id}"]`);
      const newButton = document.querySelector(`button[data-map-icon="${id}"]`);
      const newLabel = newIconGroup.querySelector('span');
      
      newLabel.style.opacity = '1';
      newButton.classList.add('is-active');
      newLabel.style.setProperty('--after-height', '20px');
      this.activeIconId = id;
    }
}

const mapImage = document.getElementById('map-image');
const mapDrag = document.getElementById('map-drag');
if (mapImage && mapDrag) {
    // Check if we're on desktop
    const isDesktop = window.innerWidth >= 1024; // 1024px is Tailwind's lg breakpoint
    
    const draggableMap = new DraggableMap(mapImage, mapDrag, {
        dragResistance: 0.3,
        edgeResistance: 0.9,
        initialX: isDesktop ? 0 : -190, // Set to 0 for desktop
        initialY: isDesktop ? 0 : -50   // Set to 0 for desktop
    });

    // Handle resize
    window.addEventListener('resize', () => {
        const newIsDesktop = window.innerWidth >= 1024;
        if (newIsDesktop !== isDesktop) {
            // Reinitialize with new positions
            draggableMap.destroy();
            const updatedDraggableMap = new DraggableMap(mapImage, mapDrag, {
                dragResistance: 0.3,
                edgeResistance: 0.9,
                initialX: newIsDesktop ? 0 : -190,
                initialY: newIsDesktop ? 0 : -50
            });
        }
    });

    const mapInteractions = new MapInteractions();
};

// Find all accordion elements
const accordions = document.querySelectorAll('[data-accordion]');
if (accordions) {
        
    // Function to handle map overlay visibility
    const updateMapOverlays = function(mapType) {
    // Hide all map type overlays
    const mapOverlays = document.querySelectorAll('[data-map-type]');
    mapOverlays.forEach(overlay => {
        overlay.style.display = 'none';
        overlay.classList.remove('z-[12]');
        overlay.classList.add('z-[11]');
    });
    
    // Show the selected map type overlay
    if (mapType) {
        const selectedOverlay = document.querySelector(`[data-map-type="${mapType}"]`);
        if (selectedOverlay) {
            selectedOverlay.style.display = 'block';
            selectedOverlay.classList.add('z-[12]');
            selectedOverlay.classList.remove('z-[11]');
        }
    }
    };
    
    // Function to open an accordion
    const openAccordion = function(accordion) {
        if (accordion) {
            const trigger = accordion.querySelector('[data-accordion-trigger]');
            const content = accordion.querySelector('[data-accordion-content]');
            const caratIcon = trigger.querySelector('.icon-carat-down');
            
            // Show content
            content.style.display = 'block';
            
            // Rotate carat icon
            if (caratIcon) {
                caratIcon.style.transform = 'rotate(180deg)';
            }
            
            // Update map overlay
            const mapType = trigger.getAttribute('data-map');
            updateMapOverlays(mapType);
        }
    };
    
    // Function to close an accordion
    const closeAccordion = function(accordion) {
    const trigger = accordion.querySelector('[data-accordion-trigger]');
    const content = accordion.querySelector('[data-accordion-content]');
    const caratIcon = trigger.querySelector('.icon-carat-down');
    
    // Hide content
    content.style.display = 'none';
    
    // Reset carat icon
    if (caratIcon) {
        caratIcon.style.transform = 'rotate(0deg)';
    }
    };
    
    // Initialize accordions - hide all content first
    accordions.forEach(accordion => {
        const content = accordion.querySelector('[data-accordion-content]');
        content.style.display = 'none';
    });
    
    // Set up click event listeners
    accordions.forEach((accordion, index) => {
    const trigger = accordion.querySelector('[data-accordion-trigger]');
    
    trigger.addEventListener('click', function(e) {
        e.preventDefault();
        
        const content = accordion.querySelector('[data-accordion-content]');
        const isOpen = content.style.display === 'block';
        
        // Close all accordions
        accordions.forEach(otherAccordion => {
        if (otherAccordion !== accordion) {
            closeAccordion(otherAccordion);
        }
        });
        
        // Toggle current accordion
        if (isOpen) {
        closeAccordion(accordion);
        
        // If closing the current accordion, open the first one to ensure one is always open
        openAccordion(accordions[0]);
        } else {
        openAccordion(accordion);
        }
    });
    
    // Optional: Add hover effect for map icons in accordion content
    const mapIconButtons = accordion.querySelectorAll('[data-map-icon]');
    mapIconButtons.forEach(button => {
        button.addEventListener('click', function() {
        const iconId = this.getAttribute('data-map-icon');
        const mapIcon = document.querySelector(`[data-map-icon="${iconId}"]`);
        
        // Highlight the selected map icon or focus on it
        // Add your implementation here if needed
        });
        
        // Add mouse enter/leave events to show tooltip on map
        button.addEventListener('mouseenter', function() {
        const iconId = this.getAttribute('data-map-icon');
        const mapIcon = document.querySelector(`div[data-map-icon="${iconId}"]`);
        
        if (mapIcon) {
            const tooltip = mapIcon.querySelector('span');
            if (tooltip) {
            tooltip.style.opacity = '1';
            }
        }
        });
        
        button.addEventListener('mouseleave', function() {
        const iconId = this.getAttribute('data-map-icon');
        const mapIcon = document.querySelector(`div[data-map-icon="${iconId}"]`);
        
        if (mapIcon) {
            const tooltip = mapIcon.querySelector('span');
            if (tooltip) {
            tooltip.style.opacity = '0';
            }
        }
        });
    });
    });
    
    // Only open the first accordion by default if viewport width is >= 768px
    if (window.innerWidth >= 768) {
        openAccordion(accordions[0]);
    }
}

// Staff accordion 
const toggleButtons = document.querySelectorAll('[data-toggle]');
const contentGroups = document.querySelectorAll('[data-group]');
const toggleContainer = document.querySelector('[data-toggle-container]');

if (toggleButtons.length && contentGroups.length && toggleContainer) {
  
    // Function to show a specific content group and hide others
    function showContentGroup(groupId) {
    // Hide all content groups
    contentGroups.forEach(group => {
        group.style.display = 'none';
    });
    
    // Show the selected content group
    const targetGroup = document.querySelector(`[data-group="${groupId}"]`);
    if (targetGroup) {
        targetGroup.style.display = 'block';
    }
    
    // Update active state for toggle buttons
    toggleButtons.forEach(button => {
        const buttonId = button.getAttribute('data-toggle');
        
        if (buttonId === groupId) {
        // Active button
        button.classList.add('active');
        button.classList.add('font-bold');
        button.classList.add('text-purple');
        } else {
        // Inactive button
        button.classList.remove('active');
        button.classList.remove('font-bold');
        button.classList.remove('text-purple');
        }
    });
    }

    // Add click event listeners to toggle buttons
    toggleButtons.forEach(button => {
    button.addEventListener('click', function() {
        const groupId = this.getAttribute('data-toggle');
        showContentGroup(groupId);
    });
    });

    // Show the first content group by default
    if (toggleButtons.length > 0) {
    const firstGroupId = toggleButtons[0].getAttribute('data-toggle');
    showContentGroup(firstGroupId);
    }

    // Optional: Add keyboard navigation for accessibility
    document.addEventListener('keydown', function(e) {
    // Find the currently active button
    const activeButton = document.querySelector('[data-toggle].active');
    if (!activeButton) return;
    
    const buttons = Array.from(toggleButtons);
    const currentIndex = buttons.indexOf(activeButton);
    let newIndex;
    
    // Navigate with arrow keys
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        newIndex = (currentIndex + 1) % buttons.length;
        e.preventDefault();
    } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + buttons.length) % buttons.length;
        e.preventDefault();
    } else {
        return;
    }
    
    // Activate the new button
    const newButton = buttons[newIndex];
    const groupId = newButton.getAttribute('data-toggle');
    showContentGroup(groupId);
    newButton.focus();
    });
}

const modalTriggers = document.querySelectorAll('[data-modal-trigger]');
if (modalTriggers) {
    
    function modalActions() {
        const modalContainer = document.querySelector('[data-modal-container]');
        const modalTriggers = document.querySelectorAll('[data-modal-trigger]');
        const closeButtons = document.querySelectorAll('[data-modal-close]');
        if (modalContainer && modalTriggers.length) {
            // Open Modal
            modalTriggers.forEach(trigger => {
                trigger.addEventListener('click', function() {
                    const targetId = this.getAttribute('data-modal-trigger');
                    const targetModal = document.querySelector(`[data-modal="${targetId}"]`);
                    
                    if (targetModal) {
                        modalContainer.classList.remove('hidden');
                        modalContainer.classList.add('z-52');
                        void modalContainer.offsetWidth;
                        modalContainer.classList.add('opacity-100');
                        setTimeout(() => {
                            targetModal.classList.add('opacity-100');
                            targetModal.classList.add('z-52');
                        }, 100);
                    }
                });
            });
            
            // Close Modal
            closeButtons.forEach(button => {
                button.addEventListener('click', function() {
                    const activeModal = document.querySelector('[data-modal].opacity-100');
                    if (activeModal) {
                        activeModal.classList.remove('opacity-100');
                        activeModal.classList.remove('z-52');
                    }
                    setTimeout(() => {
                        modalContainer.classList.remove('opacity-100');
                        setTimeout(() => {
                            modalContainer.classList.add('hidden');
                            modalContainer.classList.remove('z-52');
                        }, 500);
                    }, 300);
                });
            });
        }
    }

    modalActions();

    // Re-initialize after HTMX swaps
    htmx.on('htmx:afterSwap', function(event) {
        modalActions();
    });
}

// Get all dropdown toggle buttons
const dropdownToggleButtons = document.querySelectorAll('[data-toggle-dropdown]');

if (dropdownToggleButtons.length) {
    // Add click event listener to each toggle button
    dropdownToggleButtons.forEach(toggleButton => {
        toggleButton.addEventListener('click', (e) => {
            e.preventDefault();
            
            // Find the associated dropdown container
            const dropdownId = toggleButton.getAttribute('data-toggle-dropdown');
            const dropdownContainer = document.querySelector(`[data-dropdown-container="${dropdownId}"]`);
            
            if (dropdownContainer) {
                // Toggle classes for the dropdown container
                dropdownContainer.classList.toggle('max-h-0');
                dropdownContainer.classList.toggle('border');
                dropdownContainer.classList.toggle('border-[#EAEAEA]');
                dropdownContainer.classList.toggle('shadow-[0_4px_16px_rgba(0,0,0,0.08)]');
                dropdownContainer.classList.toggle('max-h-full');
                
                // Toggle an active class on the button itself for styling
                toggleButton.classList.toggle('active');
                
                // Close other open dropdowns when opening this one
                const otherDropdowns = document.querySelectorAll('[data-dropdown-container]');
                otherDropdowns.forEach(dropdown => {
                    if (dropdown !== dropdownContainer && dropdown.classList.contains('max-h-full')) {
                        dropdown.classList.remove('max-h-full');
                        dropdown.classList.add('max-h-0');
                        dropdownContainer.classList.toggle('border');
                        dropdownContainer.classList.toggle('border-[#EAEAEA]');
                        dropdownContainer.classList.toggle('shadow-[0_4px_16px_rgba(0,0,0,0.08)]');
                        
                        // Also remove active class from other toggle buttons
                        const otherButton = document.querySelector(`[data-toggle-dropdown="${dropdown.getAttribute('data-dropdown-container')}"]`);
                        if (otherButton) {
                            otherButton.classList.remove('active');
                        }
                    }
                });
            }
        });
    });
    
    // Handle clicks on dropdown items
    document.addEventListener('click', (e) => {
        // Check if the clicked element is a dropdown item (you can adjust the selector)
        const dropdownItem = e.target.closest('[data-dropdown-item]');
        
        if (dropdownItem) {
            // Find the parent dropdown container
            const dropdownContainer = dropdownItem.closest('[data-dropdown-container]');
            
            if (dropdownContainer) {
                // Find the associated toggle button
                const dropdownId = dropdownContainer.getAttribute('data-dropdown-container');
                const toggleButton = document.querySelector(`[data-toggle-dropdown="${dropdownId}"]`);
                
                if (toggleButton) {
                    // Update the toggle button text with the selected item's text
                    const buttonSpan = toggleButton.querySelector('span');
                    if (buttonSpan) {
                        buttonSpan.textContent = dropdownItem.textContent.trim();
                    }
                    
                    // Remove any previous selection indicator
                    const allItems = dropdownContainer.querySelectorAll('[data-dropdown-item]');
                    allItems.forEach(item => {
                        item.classList.remove('selected');
                    });
                    
                    // Add selected class to the clicked item
                    dropdownItem.classList.add('selected');
                    
                    // Close the dropdown
                    dropdownContainer.classList.remove('max-h-full');
                    dropdownContainer.classList.add('max-h-0');
                    dropdownContainer.classList.remove('border');
                    dropdownContainer.classList.remove('border-[#EAEAEA]');
                    dropdownContainer.classList.remove('shadow-[0_4px_16px_rgba(0,0,0,0.08)]');
                    toggleButton.classList.remove('active');
                }
            }
        } else if (!e.target.closest('[data-toggle-dropdown]') && !e.target.closest('[data-dropdown-container]')) {
            // Close dropdowns when clicking outside
            const openDropdowns = document.querySelectorAll('[data-dropdown-container].max-h-full');
            openDropdowns.forEach(dropdown => {
                dropdown.classList.remove('max-h-full');
                dropdown.classList.add('max-h-0');
                dropdownContainer.classList.remove('border');
                dropdownContainer.classList.remove('border-[#EAEAEA]');
                dropdownContainer.classList.remove('shadow-[0_4px_16px_rgba(0,0,0,0.08)]');
                
                // Remove active class from toggle buttons
                const toggleButton = document.querySelector(`[data-toggle-dropdown="${dropdown.getAttribute('data-dropdown-container')}"]`);
                if (toggleButton) {
                    toggleButton.classList.remove('active');
                }
            });
        }
    });
}

// Find all floor plan modal containers
const floorPlanContainers = document.querySelectorAll('[data-modal]');
if (floorPlanContainers) {    
    floorPlanContainers.forEach(modal => {
    // Find the image container within this modal
    const imageContainer = modal.querySelector('[data-modal-image-container]');
    
    if (imageContainer) {
        // Find the actual image
        const floorPlanImage = imageContainer.querySelector('img');
        
        if (floorPlanImage && window.innerWidth < 768) { // Only on mobile
        // Set up touch/drag scrolling
        let isDown = false;
        let startX;
        let currentX = 0;
        let initialTranslate = 0;
        let rafID = null; // For request animation frame
        
        // Create a scrollable container
        const scrollContainer = imageContainer.querySelector('[data-modal-image-wrapper]');
        
        if (scrollContainer) {
            // Set initial styles
            scrollContainer.style.minWidth = '200%';
            scrollContainer.style.display = 'block';
            scrollContainer.style.willChange = 'transform'; // Performance hint
            scrollContainer.style.transform = 'translateX(0)';
            imageContainer.style.overflow = 'hidden';
            
            // Calculate boundaries once image is loaded
            floorPlanImage.onload = function() {
            // Wait a bit for layout to complete
            setTimeout(() => {
                // Force a reflow to ensure dimensions are correct
                scrollContainer.offsetWidth;
            }, 100);
            };
            
            // Apply transform with requestAnimationFrame for smoother animation
            function applyTransform(x) {
            if (rafID) cancelAnimationFrame(rafID);
            
            rafID = requestAnimationFrame(() => {
                scrollContainer.style.transform = `translateX(${x}px)`;
                rafID = null;
            });
            }
            
            // Mouse events for desktop
            scrollContainer.addEventListener('mousedown', (e) => {
            isDown = true;
            startX = e.pageX;
            initialTranslate = currentX;
            scrollContainer.style.cursor = 'grabbing';
            }, { passive: false });
            
            window.addEventListener('mouseup', () => {
            if (!isDown) return;
            isDown = false;
            scrollContainer.style.cursor = 'grab';
            }, { passive: true });
            
            window.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            
            const x = e.pageX;
            const moveX = x - startX;
            
            // Calculate boundaries based on current container sizes
            const maxTranslate = 0;
            const minTranslate = -(scrollContainer.offsetWidth - imageContainer.offsetWidth);
            
            currentX = Math.min(maxTranslate, Math.max(minTranslate, initialTranslate + moveX));
            applyTransform(currentX);
            }, { passive: false });
            
            // Touch events for mobile with passive listeners where possible
            scrollContainer.addEventListener('touchstart', (e) => {
            isDown = true;
            startX = e.touches[0].pageX;
            initialTranslate = currentX;
            }, { passive: true });
            
            window.addEventListener('touchend', () => {
            isDown = false;
            }, { passive: true });
            
            window.addEventListener('touchmove', (e) => {
            if (!isDown) return;
            
            const x = e.touches[0].pageX;
            const moveX = x - startX;
            
            // Calculate boundaries based on current container sizes
            const maxTranslate = 0;
            const minTranslate = -(scrollContainer.offsetWidth - imageContainer.offsetWidth);
            
            currentX = Math.min(maxTranslate, Math.max(minTranslate, initialTranslate + moveX));
            applyTransform(currentX);
            }, { passive: false });
            
            // Add momentum scrolling with easing
            let velocity = 0;
            let lastX = 0;
            let lastTime = 0;
            
            function updateVelocity(x) {
            const now = Date.now();
            if (lastTime) {
                const dt = Math.max(1, now - lastTime);
                velocity = 0.8 * velocity + 0.2 * (x - lastX) / dt;
            }
            lastX = x;
            lastTime = now;
            }
            
            function applyMomentum() {
            if (Math.abs(velocity) < 0.1) return;
            
            velocity *= 0.95; // Friction
            
            const maxTranslate = 0;
            const minTranslate = -(scrollContainer.offsetWidth - imageContainer.offsetWidth);
            
            currentX += velocity * 16; // 16ms is roughly a frame
            currentX = Math.min(maxTranslate, Math.max(minTranslate, currentX));
            
            applyTransform(currentX);
            
            if (Math.abs(velocity) >= 0.1) {
                requestAnimationFrame(applyMomentum);
            }
            }
            
            // Track velocity during touch moves
            const originalTouchMove = scrollContainer.ontouchmove;
            scrollContainer.addEventListener('touchmove', (e) => {
            if (!isDown) return;
            updateVelocity(e.touches[0].pageX);
            }, { passive: true });
            
            scrollContainer.addEventListener('touchend', () => {
            if (Math.abs(velocity) > 0.1) {
                requestAnimationFrame(applyMomentum);
            }
            }, { passive: true });
        }
        }
    }
    });
}

function wrapElementsWithSameDataId() {
    // Step 1: Find all elements with data-id attribute
    const elementsWithDataId = Array.from(document.querySelectorAll('[data-id]'));
    
    // Step 2: Group elements by their data-id value
    const groupedElements = {};
    
    elementsWithDataId.forEach(element => {
      const dataId = element.getAttribute('data-id');
      
      if (!groupedElements[dataId]) {
        groupedElements[dataId] = [];
      }
      
      groupedElements[dataId].push(element);
    });
    
    // Step 3: Process each group
    const dataIds = Object.keys(groupedElements);
    for (let i = 0; i < dataIds.length; i++) {
      const dataId = dataIds[i];
      const elements = groupedElements[dataId];
      
      // Skip if there's only one element with this data-id
      if (elements.length < 2) continue;
      
      // Get first and last elements
      const firstElement = elements[0];
      const lastElement = elements[elements.length - 1];
      
      // Create a range to wrap the elements
      const range = document.createRange();
      range.setStartBefore(firstElement);
      range.setEndAfter(lastElement);
      
      // Create the wrapper div
      const wrapperDiv = document.createElement('div');
      wrapperDiv.setAttribute('id', dataId);
      
      // Wrap the elements
      range.surroundContents(wrapperDiv);
    }

    // Step 4: Attach the scroll listeners
    const navLinks = document.querySelectorAll('a[data-anchor]');
    if (navLinks.length) {
        // Create a map to store sections and their corresponding nav links
        const sectionToNavMap = new Map();
        
        // Build an array of sections and create the mapping
        const sections = Array.from(navLinks).map(link => {
            const id = link.getAttribute("href").substring(1);
            const section = document.getElementById(id);
            if (section) {
                sectionToNavMap.set(section, link);
            }
            return section;
        }).filter(Boolean); // Remove any null sections


        // Get the toggle button and sibling nav
        const toggleButton = document.querySelector('[data-toggle-subnav]');
        const subNav = toggleButton ? document.querySelector('[data-subnav-container]') : null;
        
        // Check if we're on mobile
        let isMobile = window.innerWidth <= 768;

        // Options for the IntersectionObserver
        const observerOptions = {
            rootMargin: '-20% 0px -20% 0px', // Add margins to make activation more precise
            threshold: [0, 0.25, 0.5, 0.75, 1] // Multiple thresholds for smoother transitions
        };

        let currentActiveSection = null;

        const observerCallback = (entries) => {
            // Store all intersecting sections and their intersection ratios
            const visibleSections = entries.filter(entry => entry.isIntersecting)
                .map(entry => ({
                    section: entry.target,
                    ratio: entry.intersectionRatio
                }));

            if (visibleSections.length > 0) {
                // Find the section with the highest intersection ratio
                const mostVisible = visibleSections.reduce((prev, current) => 
                    current.ratio > prev.ratio ? current : prev
                );

                if (mostVisible.section !== currentActiveSection) {
                    // Remove active class from all nav links
                    navLinks.forEach(link => {
                        link.classList.remove('active');
                    });

                    // Add active class to the nav link corresponding to the most visible section
                    const activeLink = sectionToNavMap.get(mostVisible.section);
                    if (activeLink) {
                        activeLink.classList.add('active');
                        
                        // Update the toggle button span with the active section name when on mobile
                        if (isMobile && toggleButton) {
                            const buttonSpan = toggleButton.querySelector('span');
                            if (buttonSpan) {
                                buttonSpan.textContent = activeLink.textContent;
                            }
                        }
                    }

                    currentActiveSection = mostVisible.section;
                }
            }
        };

        // Create and apply the observer
        const sectionObserver = new IntersectionObserver(observerCallback, observerOptions);
        
        // Observe all sections
        sections.forEach(section => {
            if (section) {
                sectionObserver.observe(section);
            }
        });

        // Add click event listeners to smooth scroll to sections
        navLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const targetId = link.getAttribute('href').substring(1);
                const targetSection = document.getElementById(targetId);
                
                if (targetSection) {
                    targetSection.scrollIntoView({
                        behavior: 'smooth'
                    });
                    
                    // If on mobile, close the subnav after clicking a link
                    if (isMobile && subNav) {
                        subNav.classList.remove('open');
                    }
                }
            });
        });
        
        // Add toggle functionality for mobile
        if (toggleButton && subNav) {
            // Set initial state - make sure the button span shows the active section text if any
            const initActiveLink = document.querySelector('a[data-anchor].active');
            if (isMobile && initActiveLink) {
                const buttonSpan = toggleButton.querySelector('span');
                if (buttonSpan) {
                    buttonSpan.textContent = initActiveLink.textContent;
                }
            }
            
            // Toggle the subnav when the button is clicked
            toggleButton.addEventListener('click', (e) => {
                e.preventDefault();
                subNav.classList.toggle('max-h-0');
                subNav.classList.toggle('border');
                subNav.classList.toggle('border-[#EAEAEA]');
                subNav.classList.toggle('shadow-[0_4px_16px_rgba(0,0,0,0.08)]');
                subNav.classList.toggle('max-h-full');
            });
            
            // Update mobile state on resize
            window.addEventListener('resize', () => {
                const wasMobile = isMobile;
                isMobile = window.innerWidth <= 768;
                
                // If transitioning from desktop to mobile, update the toggle button text
                if (!wasMobile && isMobile) {
                    const activeLink = document.querySelector('a[data-anchor].active');
                    if (activeLink) {
                        const buttonSpan = toggleButton.querySelector('span');
                        if (buttonSpan) {
                            buttonSpan.textContent = activeLink.textContent;
                        }
                    }
                }
                
                // If transitioning from mobile to desktop, ensure the subnav is visible
                if (wasMobile && !isMobile && subNav) {
                    subNav.classList.remove('open');
                }
            });
        }
    }
}
  
// Execute the function when DOM is fully loaded
document.addEventListener('DOMContentLoaded', wrapElementsWithSameDataId);
